import React, { createContext, useContext, useState, ReactNode } from "react";
import { isWeb } from "../utils/user-agent";

interface PullToRefreshContextType {
  isPullable: boolean;
  setIsPullable: (isPullable: boolean) => void;
}

const PullToRefreshContext = createContext<
  PullToRefreshContextType | undefined
>(undefined);

export const PullToRefreshProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isPullable, setIsPullable] = useState<boolean>(!isWeb());

  return (
    <PullToRefreshContext.Provider value={{ isPullable, setIsPullable }}>
      {children}
    </PullToRefreshContext.Provider>
  );
};

export const usePullToRefresh = (): PullToRefreshContextType => {
  const context = useContext(PullToRefreshContext);
  if (!context) {
    throw new Error(
      "usePullToRefresh must be used within a PullToRefreshProvider"
    );
  }
  return context;
};
